import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import RakshanPreloader from './components/RakshanPreloader';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Skill from './pages/Skill';
import Projects from './pages/Projects';
import Freelance from './pages/Freelance';
import BatonSpotlight from './components/BatonSpotlight';
import ElmorySpotlight from './components/ElmorySpotlight';
import Experience from './pages/Experience';
import Education from './pages/Education';
import Chatbot from './pages/Chatbot';
import ProjectDetailsPage from './components/ProjectDetailsPage';

function AppContent() {
  const [showPreloader, setShowPreloader] = useState(true);
  const reduceMotion = useReducedMotion();

  const handlePreloaderComplete = () => {
    setShowPreloader(false);
  };

  return (
    <div className="relative min-h-screen bg-[var(--bg-canvas)] text-[var(--fg-primary)] flex flex-col overflow-x-hidden">
      <AnimatePresence>
        {showPreloader ? (
          <RakshanPreloader key="preloader" onComplete={handlePreloaderComplete} />
        ) : (
          <motion.div
            key="main-content"
            className="relative z-10 flex flex-col min-h-screen"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: reduceMotion ? 0 : 0.5 }}
          >
            <Routes>
              {/* Standalone Project Details Route - No Header/Footer */}
              <Route 
                path="/project/:id/:slug" 
                element={<ProjectDetailsPage />} 
              />
              
              {/* Main Portfolio Routes */}
              <Route 
                path="/*" 
                element={
                  <>
                    <Header />
                    <main className="flex-grow pt-16">
                      <section id="home"><Home /></section>
                      <section id="about"><About /></section>
                      <section id="skill"><Skill /></section>
                      <section id="opensource"><BatonSpotlight /><ElmorySpotlight /></section>
                      <section id="projects"><Projects /></section>
                      <section id="freelance"><Freelance /></section>
                      <section id="experience"><Experience /></section>
                      <section id="education"><Education /></section>
                    </main>
                    <Chatbot />
                    <Footer />
                  </>
                } 
              />
            </Routes>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
